var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "client-selection" }, [
    _vm.clients.length == 1
      ? _c("div", { staticClass: "client-name" }, [
          _vm._v(_vm._s(_vm.clients[0].name))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.clients.length > 1
      ? _c(
          "div",
          { staticClass: "client-dropdown", class: { active: _vm.isVisible } },
          [
            _c(
              "button",
              {
                staticClass: "client-dropdown-btn",
                class: { active: _vm.isVisible },
                on: {
                  click: function($event) {
                    _vm.isVisible = !_vm.isVisible
                  }
                }
              },
              [
                _vm._v("\n      Select Clients\n      "),
                _c("font-awesome-icon", {
                  staticClass: "icon closed",
                  attrs: { icon: "angle-down", size: "lg", "fixed-width": "" }
                }),
                _vm._v(" "),
                _c("font-awesome-icon", {
                  staticClass: "icon open",
                  attrs: { icon: "angle-up", size: "lg", "fixed-width": "" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.isVisible
              ? _c(
                  "div",
                  { staticClass: "client-list" },
                  [
                    _c(
                      "b-form-group",
                      _vm._l(_vm.clients, function(client, index) {
                        return _c(
                          "b-form-checkbox",
                          {
                            key: "a_" + index,
                            attrs: {
                              value: client,
                              name: "clients",
                              disabled: _vm.shouldToggleBeDisabled(client)
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeClient($event, client, index)
                              }
                            },
                            model: {
                              value: _vm.selection,
                              callback: function($$v) {
                                _vm.selection = $$v
                              },
                              expression: "selection"
                            }
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _vm._v(_vm._s(client.name))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row text-secondary tinyfont" },
                              [
                                _c("div", { staticClass: "col" }, [
                                  _vm._v(_vm._s(client.id))
                                ])
                              ]
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clients.length > 1
      ? _c("div", { staticClass: "selected-client-list" }, [
          _c("h4", [
            _vm._v(
              _vm._s(_vm.selection.length) +
                " " +
                _vm._s(_vm.selection.length > 1 ? "Clients" : "Client") +
                " Selected"
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3883d8fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3883d8fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientSelection.vue
// module id = mYfH
// module chunks = 1